// Main style guide for theme used by styled-components
// Available as ${props => props.theme.etc}

export default {
    color: {
        red: '#DB2828',
        orange: '#F2711C',
        yellow: '#FBBD08',
        olive: '#B5CC18',
        green: '#21BA45',
        teal: '#00B5AD',
        blue: '#2185D0',
        violet: '#6435C9',
        purple: '#A333C8',
        pink: '#E03997',
        brown: '#A5673F',
        gray: '#767676',
        black: '#1B1C1D',
        lightgray: '#F1F1F1',
        starkiller: '#D6E9EF',
    },
    zIndex: {
        flashIt: 9999,
        topBar: 8888,
        sideBar: 7777,
    },
    margin: {
        gutters: '8rem',
    },
};
